module.exports = __webpack_public_path__ + "img/check.2c99c072.png";